import React from "react";
import Banner from "../../components/body/topLocationsComponents/Banner";
import { BannerData, LocationData } from "./data";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/footer/IndiaFooter/Footer";
import Location from "../../components/body/topLocationsComponents/LocationCard";
import Main_Footer from "../../components/footer/IndiaFooter/Main_Footer";

const BengaluruLocationPage = () => {
  return (
    <div>
      <Navbar />
      <div>
        <Banner BannerData={BannerData} />
        <Location LocationData={LocationData} />
      </div>
      <Main_Footer />
    </div>
  );
};

export default BengaluruLocationPage;
